import { render, staticRenderFns } from "./HistoryButton.vue?vue&type=template&id=12ba3348&scoped=true"
import script from "./HistoryButton.vue?vue&type=script&lang=js"
export * from "./HistoryButton.vue?vue&type=script&lang=js"
import style0 from "./HistoryButton.vue?vue&type=style&index=0&id=12ba3348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba3348",
  null
  
)

export default component.exports